import { broadcastUpdatedDocumentationVersionError } from 'serviceWorker/broadcasts/documentationVersions';
import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';

export function broadcastDocumentationVersionError(
  request: HttpRequestEntity,
  error: any
): void {
  if (request.method === 'PUT') {
    broadcastUpdatedDocumentationVersionError(error);
  }
}
